import { CompanyPageAccess } from './CompanyCapabilities';
import React, { useEffect, useRef, useState } from 'react';
import { PageVisibility } from '../hooks/usePageVisible';
import { Route, Routes, useLocation } from 'react-router-dom';

// Mount each screen on its first visit, then retain its state within this login.
// Hidden screens retain a fixed route context; the visible screen must receive
// search/hash/state changes so deep links and query-driven panels work.
export default function WorkspacePages({ pages }) {
  const location = useLocation();
  const [visited, setVisited] = useState([]);
  const active = location.pathname;
  const locations = useRef({});
  locations.current[active] = location;
  useEffect(() => {
    if (pages[active]) setVisited(previous => previous.includes(active) ? previous : [...previous, active]);
  }, [active, pages]);
  const paths = [...new Set([...visited, ...(pages[active] ? [active] : [])])];
  return paths.map(path => <section key={path} hidden={active !== path} style={{ height: '100%', display: active === path ? 'block' : 'none' }}>
    <PageVisibility.Provider value={active === path}><Routes location={active === path ? location : locations.current[path] || path}><Route path={path} element={<CompanyPageAccess path={path}>{pages[path]}</CompanyPageAccess>} /></Routes></PageVisibility.Provider>
  </section>);
}
